import React from "react";
import { Link } from "react-router-dom";

export const SubscriptionRequired: React.FC = () => {
  return (
    <div className="subscription-required text-center p-4">
      <h2 className="text-danger mb-3">
        Flangoo® Creator Subscription Required
      </h2>
      <p className="mb-4">
        To access this content, you need to purchase a Flangoo® Creator
        Subscription subscription. <br />
        Unlock exclusive content and enjoy all the features we offer!
      </p>
      <div className="d-flex justify-content-center">
        <Link to="/purchaseplan" className="btn btn-primary btn-lg mx-2">
          View Subscription Plans
        </Link>
        <Link to="/help" className="btn btn-outline-secondary btn-lg mx-2">
          Contact Support
        </Link>
        <Link to="/creator" className="btn btn-outline-secondary btn-lg mx-2">
          Learn More
        </Link>
      </div>
    </div>
  );
};

interface SkeletonBooksProps {
  count: number;
}

export const SkeletonBooks: React.FC<SkeletonBooksProps> = ({ count }) => {
  return (
    <div className="skeleton-books d-flex flex-wrap justify-content-center">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="skeleton-book m-2">
          <div
            className="skeleton-cover bg-secondary"
            style={{ width: "180px", height: "252px", borderRadius: "10px" }}
          ></div>
        </div>
      ))}
    </div>
  );
};
